import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Gamepad2, Gift, Smartphone, Flame } from 'lucide-react';

const tabs = [
  { icon: Home, label: 'Home', route: '/' },
  { icon: Gamepad2, label: 'Games', route: '/category/games' },
  { icon: Gift, label: 'Rewards', route: '/category/rewards' },
  { icon: Smartphone, label: 'Apps', route: '/category/apps' },
  { icon: Flame, label: 'Hot', route: '/category/hot' },
];

const DesktopTabBar = () => {
  return (
    <nav className="hidden md:flex flex-col items-center gap-2 fixed left-0 top-14 bottom-0 w-20 bg-[#0f0f0f] border-r border-gray-800 z-50 p-2">
      {tabs.map((tab) => (
        <NavLink
          key={tab.label}
          to={tab.route}
          className={({ isActive }) => `
            flex flex-col items-center justify-center gap-1 w-full transition-colors py-3
            ${isActive ? 'text-indigo-500' : 'text-gray-500'}
          `}
        >
          <tab.icon className="w-6 h-6" />
          <span className="text-[10px] font-medium">{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default DesktopTabBar;
